import { createPluginFactory, onKeyDownToggleMark } from '@udecode/plate-core';

const MARK_HIGHLIGHT = 'highlight';
/**
 * Enables support for highlights, useful when reviewing
 * content or highlighting it for future reference.
 */

const createHighlightPlugin = createPluginFactory({
  key: MARK_HIGHLIGHT,
  isLeaf: true,
  handlers: {
    onKeyDown: onKeyDownToggleMark
  },
  deserializeHtml: {
    rules: [{
      validNodeName: ['MARK']
    }]
  },
  options: {
    hotkey: 'mod+shift+h'
  }
});

export { MARK_HIGHLIGHT, createHighlightPlugin };
//# sourceMappingURL=index.es.js.map
